// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginPage_formContainer__HyciO","formTitle":"LoginPage_formTitle__JrEss"};